import React from 'react';
import {
	compose,
	lifecycle
  } from 'recompose';
import config from '../../config';
import { HTMLTrans, withTranslation } from '../Common/Translations';

const VoucherExpired = () => {
  return (
    <div>
		<div className="dashboard__component bg-gray-lighten-3 p-3 p-lg-6">
			<div className="container text-center px-0">
				<div>
					<img src={`${config.s3BucketUrl}/assets/email/icons/prp_expired_used.png`} width="176"/>
				</div>
				<p className='voucher-expired-title'>
					<HTMLTrans id="voucher_expired.voucher_expired_title">
						Oops! Your Voucher Has Expired or Already Used
					</HTMLTrans>
				</p>
				<div className='d-flex justify-content-center mb-3'>
					<div className='voucher-expired-description '>
						<p>
						<HTMLTrans id="voucher_expired.voucher_expired_description">
							It seems there's an issue with your prepaid voucher. It may have expired or already been used.
							Don't worry, you can still enjoy our services! Visit our promotion page to find out about the latest deals!
						</HTMLTrans>
						</p>
					</div>
				</div>
				<div className='mb-2'>
					<a href="/" className='btn home-page text-capitalize mx-2 mb-1'>
						<HTMLTrans id='voucher_expired.go_to_home_page'>Go to Home Page</HTMLTrans>
					</a>

					<a href="/promotions" className='btn btn-primary text-capitalize mx-2 mb-1'>
						<HTMLTrans id='voucher_expired.go_to_promotions'>Go to Promotions</HTMLTrans>
					</a>
				</div>
			</div>
		</div>
    </div>
  );
};

const enhance = compose(
	withTranslation('voucher_expired'),
	lifecycle({
		 componentDidMount() {
			document.getElementsByTagName('main')[0].style.minHeight = 'auto';
		 }
	})
)

export default enhance(VoucherExpired);
export const undecorated = VoucherExpired;



// WEBPACK FOOTER //
// ./src/StaticPage/VoucherExpired.js